export default __webpack_public_path__ + "static/mobile-building-d1b7bd871afcaf8ed85763561bef519d.png";